// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__3tGRg","block_logo":"Header_block_logo__1wglM"};